import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';
import PermissionButton from './PermissionButton';

/** The new design's create button, as on Cases: a step under the kit's 40px, semibold, with no glyph. */
export const NEW_DESIGN_CREATE_CLASS = 'h-9 px-3.5 font-semibold';

type Props = Omit<ComponentProps<typeof PermissionButton>, 'children'> & {
    /** The label classic shows. */
    labelId: string;
    /** The new design's "New <entity>". */
    newLabelId: string;
};

/**
 * A list's create button, in its header, its record tab's toolbar or its empty state. Classic renders exactly
 * what the call site passes; the new design reads "New <entity>" at Cases' size, dropping any start glyph. The
 * variant stays the call site's, so a list's secondary create action keeps its outline.
 */
export default function ListCreateButton({ labelId, newLabelId, size, className, startIcon, ...props }: Props) {
    const isNewDesign = useIsNewDesign();

    if (!isNewDesign) {
        return (
            <PermissionButton {...props} size={size} className={className} startIcon={startIcon}>
                <FormattedMessage id={labelId} />
            </PermissionButton>
        );
    }
    return (
        <PermissionButton {...props} size="small" className={cn(className, NEW_DESIGN_CREATE_CLASS)}>
            <FormattedMessage id={newLabelId} />
        </PermissionButton>
    );
}
